import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import "common/css/master.css";
import "./subjectTeacherAvailability.css";
import Loader from "common/components/Loader";
import { getAvailabilityStatusSvc } from "./subjectTeaherAvailabilitySvc";

const SubjectTeachersAvailability = (props) => {
    const { selSessionId, closePopup, selSectionId = 0 } = props;

    const [popupLoader, setPopupLoader] = useState("none");
    const [popupOpacity, setPopupOpacity] = useState(1);
    const [secFiltered, setSecFiltered] = useState("");
    const [statusFiltered, setStatusFiltered] = useState("");
    const [subjectFiltered, setSubjectFiltered] = useState("");
    const [teacherFiltered, setTeacherFiltered] = useState("");
    const [clsFiltered, setClsFiltered] = useState("");
    const [key, setKey] = useState(0);
    const [lstStatus, setLstStatus] = useState([]);
    const [lstStatusFiltered, setLstStatusFiltered] = useState([]);


    useEffect(() => {
        // console.log("SubjectTeachersAvailability called, selSectionId", selSectionId, ", selSessionId", selSessionId);
        if (selSessionId)
            getAvailabilityStatus(selSectionId, selSessionId);
    }, [selSectionId, selSessionId]);

    const saveClsPeriods = (clsObj) => {
        // console.log("saveClsPeriods called, clsObj", clsObj);
    };


    const getAvailabilityStatus = (pSectionId, pSessionId) => {
        // console.log("getAvailabilityStatus called");
        setPopupLoader("block");
        setPopupOpacity(0.5);
        getAvailabilityStatusSvc(pSectionId, pSessionId, availabilityStatusResponse);
    }


    const availabilityStatusResponse = (data) => {
        // console.log("availabilityStatusResponse called, data", JSON.stringify(data, null, 2));
        setPopupLoader("none");
        setPopupOpacity(1);
        if (data.status === "Success") {
            // console.log("availabilityStatusResponse called, data.lstStatus", JSON.stringify(data.lstStatus, null, 2));
            setLstStatus(data.lstStatus);
            setLstStatusFiltered(data.lstStatus);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
    }

    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };

    const handleClsFilter = async (val) => {
        await setClsFiltered(val);
        filterStatus(secFiltered, statusFiltered, subjectFiltered, teacherFiltered, val);
    };

    const handleSubjectFilter = async (val) => {
        await setSubjectFiltered(val);
        filterStatus(secFiltered, statusFiltered, val, teacherFiltered, clsFiltered);
    };

    const handleTeacherFilter = async (val) => {
        await setTeacherFiltered(val);
        filterStatus(secFiltered, statusFiltered, subjectFiltered, val, clsFiltered);
    };

    const handleSecFilter = async (val) => {
        await setSecFiltered(val);
        filterStatus(val, statusFiltered, subjectFiltered, teacherFiltered, clsFiltered);
    };

    const handleStatusFilter = async (val) => {
        await setStatusFiltered(val);
        filterStatus(secFiltered, val, subjectFiltered, teacherFiltered, clsFiltered);
    };

    const filterStatus = async (fSec, fStatus, fSubject, fTeacher, fCls) => {

        let filteredStatusTable = [];
        filteredStatusTable = lstStatus.filter(status =>
            status.tch.toLowerCase().includes(fTeacher.toLowerCase())
        );
        filteredStatusTable = filteredStatusTable.filter(status =>
            status.cls.toLowerCase().includes(fCls.toLowerCase())
        );
        filteredStatusTable = filteredStatusTable.filter(status =>
            status.sec.toLowerCase().includes(fSec.toLowerCase())
        );
        filteredStatusTable = filteredStatusTable.filter(status =>
            status.sub.toLowerCase().includes(fSubject.toLowerCase())
        );
        filteredStatusTable = filteredStatusTable.filter(status =>
            status.status.toLowerCase().includes(fStatus.toLowerCase())
        );


        await setLstStatusFiltered(filteredStatusTable);
    }

    const updateKey = () => {
        setKey((prevKey) => prevKey + 1);
    };

    const colgrp = <colgroup>
        <col width="25"></col>
        <col width="20"></col>
        <col width="40"></col>
        <col width="50"></col>
        <col width="30"></col>
        <col width="30"></col>
        <col width="30"></col>
        <col width="30"></col>
    </colgroup>

    return (
        <div >
            <Loader loader={popupLoader} position="fixed" />
            <div className="col-sm-12 padding-remove" style={{ height: "50px" }}>
                <div className="col-sm-8" style={{ fontSize: "large" }}>
                    Schedule Status
                </div>
                <div className="col-sm-4 padding-remove" >
                    <button type="button"
                        title="Close Popup"
                        onClick={() => {
                            // console.log("close button clicked");
                            closePopup();
                        }}
                        className='btn btn-info text-center pull-right'>X</button>
                </div>
            </div>
            <div
                className="col-md-12 col-xs-12 col-centered padding-remove"
                style={{
                    cursor: popupLoader === "none" ? "pointer" : "none",
                    pointerEvents: popupLoader === "none" ? "auto" : "none",
                    opacity: popupOpacity,
                }}
            >
                <div className="col-md-12 col-xs-12 col-centered padding-remove" >
                    <table className="tableLayout1 ">
                        {colgrp}
                        <thead>
                            <tr>
                                <th>
                                    <input
                                        type="text" className="form-control inp-search"
                                        value={clsFiltered}
                                        onChange={(e) => handleClsFilter(e.target.value)}
                                        name="Class"
                                        placeholder="Class" />

                                </th>
                                <th>
                                    <input
                                        type="text" className="form-control inp-search"
                                        value={secFiltered}
                                        onChange={(e) => handleSecFilter(e.target.value)}
                                        name="Section"
                                        placeholder="Section" />

                                </th>
                                <th>
                                    <input
                                        type="text" className="form-control inp-search"
                                        value={subjectFiltered}
                                        onChange={(e) => handleSubjectFilter(e.target.value)}
                                        name="Subject"
                                        placeholder="Subject" />

                                </th>
                                <th>
                                    <input
                                        type="text" className="form-control inp-search"
                                        value={teacherFiltered}
                                        onChange={(e) => handleTeacherFilter(e.target.value)}
                                        name="Teacher"
                                        placeholder="Teacher" />

                                </th>
                                <th>Required Periods</th>
                                <th>Allocated Periods</th>
                                <th>Pending Periods</th>
                                <th>
                                    <input
                                        type="text" className="form-control inp-search"
                                        value={statusFiltered}
                                        onChange={(e) => handleStatusFilter(e.target.value)}
                                        name="Status"
                                        placeholder="Status" />
                                </th>
                            </tr>
                        </thead>
                    </table>
                    <div className="tableDiv" style={{ height: "65vh" }}>
                        <table className="tableLayout">
                            {colgrp}
                            <tbody >
                                {lstStatusFiltered.map((cls, clsIndex) => (
                                    <tr key={clsIndex} className={cls.status.toLowerCase() === "pending" ? "status-pending" : ""}>
                                        <td className="text-left">{cls.cls}</td>
                                        <td className="text-left">{cls.sec}</td>
                                        <td className="text-center">{cls.sub}</td>
                                        <td className="text-center">{cls.tch}</td>
                                        <td className="text-center">{cls.required}</td>
                                        <td className="text-center">{cls.required - cls.pending}</td>
                                        <td className="text-center">{cls.pending}</td>
                                        <td className="text-center">{cls.status}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubjectTeachersAvailability;
